
import { windowatch } from '../../../scripts/lib/windowatch';

const name = 'button';

export default class Button {

  constructor ($el) {
    this.$el = $el;

    if ($el.classList.contains(`${name}--anchor-scroll`)) {
      $el.onclick = this.onScrollAnchorClick.bind(this);
    }
  }

  onScrollAnchorClick (evt) {
    evt.preventDefault();

    const index = this.$el.dataset.anchorTarget;
    const $module = document.querySelector(`.module--index-${index}`);

    if ($module) {
      const headerHeight =
        windowatch.getBreakpointSpec().navigationCollapsedHeight;
      const top =
        $module.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scroll({ top, left: 0, behavior: 'smooth' });
    }
  }
}
